// extracted by mini-css-extract-plugin
export var baseMap = "LayeredMap-module--base-map--14b3d";
export var container = "LayeredMap-module--container--e1173";
export var legend = "LayeredMap-module--legend--563ce";
export var legendItem = "LayeredMap-module--legend-item--9f687";
export var legendTitle = "LayeredMap-module--legend-title--aa77e";
export var legends = "LayeredMap-module--legends--dddce";
export var map = "LayeredMap-module--map--0b244";
export var mapContainer = "LayeredMap-module--map-container--cc38a";
export var marker = "LayeredMap-module--marker--78d65";
export var positionBottomLeft = "LayeredMap-module--position-bottom-left--3db0c";
export var positionBottomRight = "LayeredMap-module--position-bottom-right--078d4";
export var positionTopLeft = "LayeredMap-module--position-top-left--d9182";
export var positionTopRight = "LayeredMap-module--position-top-right--8478c";
export var srOnly = "LayeredMap-module--sr-only--02e39";